// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
declare var DBSService_BASE_URL: string;

export const environment = {
  production: false,
  /** Set to true to bypass MSAL auth and use CURRENT_USER_* values from index.html */
  devBypassAuth: false,
  apiBaseUrl: DBSService_BASE_URL,
  KENDO_UI_LICENSE: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkxJQyJ9.eyJwcm9kdWN0cyI6W3sidHJpYWwiOmZhbHNlLCJjb2RlIjoiS0VORE9VSVJFQUNUIiwibGljZW5zZUV4cGlyYXRpb25EYXRlIjoxNzI3MzQ1MzExfSx7InRyaWFsIjpmYWxzZSwiY29kZSI6IktFTkRPVUlDT01QTEVURSIsImxpY2Vuc2VFeHBpcmF0aW9uRGF0ZSI6MTcyNzM0NTMxMX0seyJ0cmlhbCI6ZmFsc2UsImNvZGUiOiJLRU5ET1VJVlVFIiwibGljZW5zZUV4cGlyYXRpb25EYXRlIjoxNzI3MzQ1MzExfSx7InRyaWFsIjpmYWxzZSwiY29kZSI6IktFTkRPVUlBTkdVTEFSIiwibGljZW5zZUV4cGlyYXRpb25EYXRlIjoxNzI3MzQ1MzExfV0sImludGVncml0eSI6InBmRmtIcGZ1YmI2NUt5NEduZk5cL08yYUtJbDA9IiwibGljZW5zZUhvbGRlciI6ImRlZWtzaGEuZ2FuanVAaGFsbGlidXJ0b24uY29tIiwiaWF0IjoxNjk4OTMyOTczLCJhdWQiOiJkZWVrc2hhLmdhbmp1QGhhbGxpYnVydG9uLmNvbSIsInVzZXJJZCI6Ijc2ZGY2ZmI5LWQyM2EtNDEzNy1iMjdiLWQyMmQ5ZWZhZTk1MCJ9.SVFHlJezZn4Xp6S1OYH8bPQud_8tBTKL9mGmcOm6TJOmkwRT00TCdj6DJBF0mmeHhwMVvKTxgB7R9IxsxPNTxcND1ZHS26Qx2sFw7c7R4DK8LYgswuCOXXaVV11-iIXLefUvDokuHeoE-WGV_pLezUho2cCQWIYHa32r-xl9KKsEJSnovn0-lnfa7CVVUiD4C9ItXr6zTaVsEbzVyRD59z8nETDapcJ2Bxra90liMkCC4OYVN-WvnRriJykUUMAem7bqEaeAO5LFqhaD6ufChRWU-FsIOa-hpmDNI1Kr_K_NJ0U27AQFcJXf65Xz_zyYl0Vxi3WLr8EcbdNjjuJaLg',
  asset_location: 'assets',
  fileVaultApiUrl: DBSService_BASE_URL +'/api/v1',
  bitwitAi: {
    baseUrl: '',
    projectName: '',
    deploymentName: '',
    apiVersion: '2024-05-01-preview',
    apiKey: '',
    defaultTemperature: 0.2,
    defaultMaxTokens: 800,
    telemetryEnabled: true,
  },
  azureAd: {
    clientId: '5da39247-6091-47df-b59c-60c799f4a18c', // Application (client) ID (without api:// prefix)
    tenantId: 'b7be7686-6f97-4db7-9081-a23cf09a96b5', // Directory (tenant) ID
     redirectUri: window.location.origin
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
